import React from 'react';

export const Loading = () => {
    return (
        <svg
            width="495"
            height="594"
            viewBox="0 0 495 594"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="264" height="32" rx="2" fill="#EBEBEB" />
            <rect y="224" width="403" height="24" rx="2" fill="#EBEBEB" />
            <rect
                x="45"
                y="275"
                width="450"
                height="24"
                rx="2"
                fill="#EBEBEB"
            />
            <rect
                x="45"
                y="334"
                width="450"
                height="24"
                rx="2"
                fill="#EBEBEB"
            />
            <rect
                x="45"
                y="393"
                width="450"
                height="24"
                rx="2"
                fill="#EBEBEB"
            />
            <rect
                x="45"
                y="452"
                width="450"
                height="24"
                rx="2"
                fill="#EBEBEB"
            />
            <rect
                x="45"
                y="511"
                width="450"
                height="24"
                rx="2"
                fill="#EBEBEB"
            />
            <rect
                x="45"
                y="570"
                width="450"
                height="24"
                rx="2"
                fill="#EBEBEB"
            />
            <rect y="129" width="179" height="40" rx="2" fill="#EBEBEB" />
            <rect
                x="195"
                y="129"
                width="149"
                height="40"
                rx="2"
                fill="#EBEBEB"
            />
            <rect x="76" y="44" width="161" height="24" rx="2" fill="#EBEBEB" />
            <rect x="76" y="80" width="161" height="24" rx="2" fill="#EBEBEB" />
            <rect y="44" width="60" height="61" fill="#EBEBEB" />
            <circle cx="18" cy="287" r="12" fill="#EBEBEB" />
            <circle cx="18" cy="346" r="12" fill="#EBEBEB" />
            <circle cx="18" cy="405" r="12" fill="#EBEBEB" />
            <circle cx="18" cy="464" r="12" fill="#EBEBEB" />
            <circle cx="18" cy="523" r="12" fill="#EBEBEB" />
            <circle cx="18" cy="582" r="12" fill="#EBEBEB" />
        </svg>
    );
};
